const selectArticles = (state, statKey, page, idxStart, idxEnd) => {
  const { articles } = state;

  if (articles[statKey] && articles[statKey][page]) {
    const { totalItems } = articles[statKey];
    return [articles[statKey][page].slice(idxStart, idxEnd), totalItems];
  }
  return [[], 0];
};

const selectProducts = (state, statKey, page) => {
  const { products } = state;

  if (products[statKey]) {
    const { totalItems } = products[statKey];
    return [products[statKey][page], totalItems];
  }
  return [[], 0];
};

const selectTabStats = (state, statKey, page, tab, idxStart, idxEnd) => {
  const stats = state.strategyTabs[tab];

  if (stats[statKey] && stats[statKey][page]) {
    const { totalItems } = stats[statKey];
    return [stats[statKey][page].slice(idxStart, idxEnd), totalItems];
  }
  return [[], 0];
};

const selectStrategyCrumb = (state, tab) => {
  if (state.strategyTabs.crumbPage !== tab) return null;
  return state.strategyTabs.crumb;
};

export { selectArticles, selectProducts, selectTabStats, selectStrategyCrumb };
